import { DateTime } from 'luxon'

/**
 * Retorna uma data no padrao dd/mm/yyyy
 * @param value Data em padrao json ou válida para conversão do tipo Javacript Date.
 */
export function formatDateFilter(value: string | undefined) {
    if (!value || value == '0001-01-01T00:00:00') return '--/--/----'

    let date = new Date(value)
    return date.toLocaleDateString('pt-BR')
}

export function fromNowFilter(value: string) {
    if (!value) return '-'
    let date = new Date(value)

    var datelx = DateTime.fromJSDate(date, {
        //zone: 'pt-BR'
        zone: 'local'
    })

    return datelx.toRelative()
}

/**
 * Retorna uma data no padrao dd/mm/yyyy hh:mm
 * @param value Data em padrao json ou válida para conversão do tipo Javacript Date.
 */
export function formatDateWithTimeFilter(value: string | undefined) {
    if (!value) return '-'

    var date = new Date(value)
    var options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    }

    //return new Intl.DateTimeFormat('pt-BR', options).format(date)
    return `${date.toLocaleString('pt-BR')}`
}

export function formatDateNominal(value: string | undefined) {
    if (!value) return '-'

    var date = new Date(value)

    //return new Intl.DateTimeFormat('pt-BR', options).format(date)
    return `${date.toLocaleString('pt-BR', {
        year: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        month: 'long'
    })}`
}

export function subtractDateResultInMonth(DtIni: Date | undefined, DtFim: Date | undefined) {
    var DtIniFormarted = formatDateFilter(DtIni?.toString())
    var DtFimFormated = formatDateFilter(DtFim?.toString())
    var DateIni = new Date(DtIniFormarted)
    var DateFim = new Date(DtFimFormated)
    var result = DateFim.getTime() - DateIni.getTime()
    result = Math.ceil(result / (1000 * 3600 * 24))
    result = result / 30
    result = parseInt(result.toPrecision(2))

    return result
}

export function getHoursByDate(value: any) {
    if (!value) return '-'

    var date = new Date(value)

    //return new Intl.DateTimeFormat('pt-BR', options).format(date)
    return `${date.toLocaleString('pt-BR', {
        hour: 'numeric',
        minute: 'numeric'
    })}`
}

export function formatDateISO(value: any) {
    if (!value) return null

    var dateParts = value.split('/')

    var date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])

    return date.toISOString()
}
